<div class="pick-and-pack-table__wrapper">
  <div
    class="overlay"
    lumAppLoader
    [loading]="loading"
    [classes]="'loading blur'"
  ></div>
  <form [formGroup]="form">
    <table class="lum-table lum-table--classic striped">
      <tr class="table__head-row">
        <th class="w-5">
          <mat-checkbox
            class="lum-checkbox"
            (change)="onCheckAllItems($event)"
            [checked]="checkedAllItems"
          >
          </mat-checkbox>
        </th>
        <th class="hidden optional-cell">Status</th>
        <th class="hidden optional-cell"></th>
        <th>SKU</th>
        <th>Product Name</th>
        <th class="text-right">Quantity / Ordered</th>
        <th class="w-auto">
          Location
          <lum-ui-icon
            class="cursor-pointer"
            (click)="sortEvent.emit({ sortField: 'location' })"
            icon="chevron-down"
            color="#212529"
          ></lum-ui-icon>
        </th>
        <th *ngIf="hasLotTracking" class="w-auto">Lot</th>
        <th *ngIf="currentPickListStatus !== picklistStatus.SHIPPED"></th>
        <th *ngIf="currentPickListStatus !== picklistStatus.SHIPPED"></th>
      </tr>
      <ng-container>
        <tbody>
          <tr
            *ngFor="
              let row of rows.controls;
              trackBy: trackByControlValue;
              let i = index
            "
            [ngClass]="{ 'table__row--splitted': row.value.tempId }"
          >
            <td>
              <mat-checkbox
                class="lum-checkbox"
                [checked]="row.value?.checked"
                (change)="onCheckItem(row)"
              >
              </mat-checkbox>
            </td>
            <td class="hidden optional-cell">
              <lum-picklist-item-status
                [statuses]="row?.value?.status"
              ></lum-picklist-item-status>
            </td>
            <td class="hidden optional-cell">
              <div>
                <lum-ui-popover
                  (setContentVisibleEvent)="
                    onLocationToggle(
                      $event,
                      row?.value?.rfqId,
                      row?.value?.locationId
                    )
                  "
                >
                  <lum-ui-icon
                    icon="location"
                    color="#6D6E73"
                    width="20px"
                    height="20px"
                  ></lum-ui-icon>

                  <div content>
                    <div>
                      <lum-picklist-item-location-breakdown
                        [locations]="locations"
                        [loading]="loadingLocations"
                      ></lum-picklist-item-location-breakdown>
                    </div>
                  </div>
                </lum-ui-popover>
              </div>
            </td>
            <td class="text-nowrap">
              <a
                *ngIf="row?.value; else noRowValue"
                [routerLink]="['/inventory', row.value.rfqId, 'view']"
                target="_blank"
                >{{ row.value.internalSku }}</a
              >
              <ng-template #noRowValue>...</ng-template>
            </td>
            <td>
              <div (touchend)="onTapInfo($event, row?.value)">
                <div class="table__column-name">
                  <div class="table__column-name__photo">
                    <img [src]="row?.value?.rfqPhoto" />
                  </div>
                  <div
                    class="table__column-name__main"
                    [matTooltip]="row?.value?.productDescription | htmlSanitizer"
                  >
                    <div class="table__column-name__title font-normal">
                      {{ row?.value?.productName }}
                    </div>
                    <div class="table__column-name__description mt-4 text-x-small">
                      {{ row?.value?.productDescription | htmlSanitizer }}
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div class="flex gap-2">
                <lum-ui-input
                  #quantityInput
                  type="number"
                  color="primary"
                  ngDefaultControl
                  placeholder="Qty."
                  cssClasses="w-35 text-right"
                  [allowDecimal]="true"
                  [index]="i"
                  [formControl]="rows | formControlGetter: i : 'pickedQuantity'"
                  [value]="row?.value?.pickedQuantity || 0 | decimalPlaces"
                  [disabled]="
                    !row?.value?.status?.includes(pickListItemStatus.IN_PROGRESS) ||
                    row?.value?.status?.includes(pickListItemStatus.DISABLED) ||
                    submittingForm
                  "
                ></lum-ui-input>
                <div class="table__cell-quantiy-limit text-nowrap">
                  / {{ row?.value?.availableQuantity | decimalPlaces }}
                </div>
              </div>
            </td>
            <td>
              <lum-ui-advance-select
                class=""
                [disabled]="
                  !row?.value?.status?.includes(pickListItemStatus.IN_PROGRESS) ||
                  row?.value?.status?.includes(pickListItemStatus.DISABLED) ||
                  submittingForm
                "
                [items]="formattedLocations"
                [loading]="loadingLocations"
                [selectedOption]="row?.value?.selectedLocation"
                (openedChange)="
                  onGetLocationsByRfqId(row?.value?.rfqId, row?.value?.locationId)
                "
                (selectOptionEvent)="
                  onSelectLocationEvent(
                    $event,
                    row?.value?.id || row?.value?.tempId
                  )
                "
              ></lum-ui-advance-select>
            </td>
            <td *ngIf="hasLotTracking">
              <lum-ui-advance-select
                placeholder="Select"
                [disabled]="
                  !row?.value?.status?.includes(pickListItemStatus.IN_PROGRESS) ||
                  row?.value?.status?.includes(pickListItemStatus.DISABLED) ||
                  !row?.value?.lotTracking ||
                  !row?.value.locationId ||
                  submittingForm
                "
                [items]="formattedLots"
                [loading]="loadingLots"
                [selectedOption]="row?.value?.selectedLot"
                (openedChange)="
                  openLotListEvent.emit({
                    rfqId: row?.value?.rfqId,
                    locationId: row?.value?.locationId,
                  })
                "
                (selectOptionEvent)="
                  onSelectLotEvent($event, row?.value?.id || row?.value?.tempId)
                "
              ></lum-ui-advance-select>
            </td>
            <td *ngIf="currentPickListStatus !== picklistStatus.SHIPPED">
              <button
                *ngIf="
                  (row?.value?.status?.includes(pickListItemStatus.IN_PROGRESS) &&
                    !row?.value?.parentId) ||
                  false
                "
                type="button"
                class="lum-button lum-button--tertiary p-2"
                mat-button
                [disabled]="submittingForm"
                (click)="onSplitEvent(row?.value?.id, i)"
              >
                Split
                <lum-ui-icon
                  class="ml-2"
                  icon="add-circle"
                  color="#5563d6"
                ></lum-ui-icon>
              </button>

              <button
                *ngIf="
                  row?.value?.parentId &&
                  !row?.value?.status?.includes(pickListItemStatus.PICKED)
                "
                type="button"
                class="lum-button lum-button--tertiary p-2"
                mat-button
                [disabled]="submittingForm"
                (click)="removeItemEvent.emit({ item: row?.value, index: i })"
              >
                Delete
                <lum-ui-icon
                  class="ml-2"
                  icon="close-circle"
                  color="#5563d6"
                  width="24"
                  height="24"
                ></lum-ui-icon>
              </button>
            </td>
            <td *ngIf="currentPickListStatus !== picklistStatus.SHIPPED">
              <button
                *ngIf="row?.value?.status?.includes(pickListItemStatus.UNPICKED)"
                type="button"
                class="lum-button lum-button--secondary p-2"
                mat-button
                [disabled]="submittingForm"
                (click)="onPickevent(row?.value, quantityInput)"
              >
                Pick
                <lum-ui-icon
                  class="ml-2"
                  icon="check-circle"
                  color="#5563D6"
                ></lum-ui-icon>
              </button>

              <button
                *ngIf="
                  row?.value?.status?.includes(pickListItemStatus.IN_PROGRESS) &&
                  !row?.value?.parentId
                "
                type="button"
                class="lum-button p-2"
                mat-button
                [disabled]="submittingForm"
                (click)="doneEvent.emit(row?.value?.id)"
              >
                Done
                <lum-ui-icon
                  class="ml-2"
                  icon="check-circle"
                  color="#ffffff"
                  width="20"
                  height="20"
                ></lum-ui-icon>
              </button>

              <button
                *ngIf="
                  row?.value?.status?.includes(pickListItemStatus.PICKED) &&
                  !row?.value?.parentId
                "
                type="button"
                class="lum-button p-2"
                mat-button
                [disabled]="submittingForm || row?.value?.isUpdated"
                (click)="resetEvent.emit(row?.value?.id)"
              >
                Reset
                <lum-ui-icon
                  class="ml-2"
                  icon="check-circle"
                  color="#ffffff"
                  width="20"
                  height="20"
                ></lum-ui-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </form>
</div>
